import { cn } from 'app/lib/utils'

const LoadingAnimation = ({ className }: { className?: string }) => {
    return (
        <div className='h-full flex flex-col'>
            <div
                className={cn(
                    `border-2 border-foreground border-t-0 mx-auto my-auto rounded-full md:size-12 size-8 transition-all animate-spin duration-500 flex`,
                    className
                )}
            ></div>
        </div>
    )
}
export default LoadingAnimation
